import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useLoader } from "../context/LoaderContext";

const ExcelToJsonViewer = () => {
  const [jsonData, setJsonData] = useState([]);
  const [fileName, setFileName] = useState("");
  const { showLoader, hideLoader } = useLoader(); // ✅ Use global loader

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    showLoader(); // ✅ Start loader

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        setJsonData(json);
      } catch (err) {
        alert("Something went wrong while parsing the file.");
      } finally {
        hideLoader(); // ✅ Stop loader
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownloadJson = () => {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(jsonData, null, 2));
    const dlAnchorElem = document.createElement("a");
    dlAnchorElem.setAttribute("href", dataStr);
    dlAnchorElem.setAttribute("download", fileName.replace(/\.[^/.]+$/, "") + ".json");
    dlAnchorElem.click();
  };

  const handleReset = () => {
    setJsonData([]);
    setFileName("");
    document.getElementById("excelFile").value = "";
  };

  return (
    <div className="mb-4">
      <input
        type="file"
        id="excelFile"
        accept=".xlsx, .xls, .csv"
        className="form-control mb-3"
        onChange={handleFileUpload}
      />

      {jsonData.length > 0 && (
        <>
          <div className="mb-3">
            <button className="btn btn-success me-2" onClick={handleDownloadJson}>Download JSON</button>
            <button className="btn btn-danger" onClick={handleReset}>Remove File</button>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  {Object.keys(jsonData[0]).map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {jsonData.map((row, i) => (
                  <tr key={i}>
                    {Object.values(row).map((val, j) => (
                      <td key={j}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ExcelToJsonViewer;
